import { mapState } from 'pinia';
import ArchivedBadge from '~/issuable/components/archived_badge.vue';
import HiddenBadge from '~/issuable/components/hidden_badge.vue';
import LockedBadge from '~/issuable/components/locked_badge.vue';
import StatusBadge from '~/issuable/components/status_badge.vue';
import { TYPE_ISSUE, TYPE_MERGE_REQUEST, NAMESPACE_PROJECT } from '~/issues/constants';
import { fetchPolicies } from '~/lib/graphql';
import ConfidentialityBadge from '~/vue_shared/components/confidentiality_badge.vue';
import ImportedBadge from '~/vue_shared/components/imported_badge.vue';
import { badgeState } from '~/merge_requests/badge_state';
import { useNotes } from '~/notes/store/legacy_notes';
export default {
    name: 'MergeRequestHeader',
    TYPE_ISSUE,
    TYPE_MERGE_REQUEST,
    NAMESPACE_PROJECT,
    components: {
        ArchivedBadge,
        ConfidentialityBadge,
        LockedBadge,
        HiddenBadge,
        ImportedBadge,
        StatusBadge
    },
    inject: {
        query: {
            default: null
        },
        projectPath: {
            default: null
        },
        hidden: {
            default: false
        },
        iid: {
            default: null
        }
    },
    props: {
        initialState: {
            type: String,
            required: false,
            default: null
        },
        isImported: {
            type: Boolean,
            required: false,
            default: false
        },
        isDraft: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapState(useNotes, [
            'getNoteableData'
        ]),
        state () {
            if (!this.iid) {
                return this.initialState;
            }
            return badgeState.state;
        },
        isArchived () {
            return this.getNoteableData.archived;
        },
        isLocked () {
            return this.getNoteableData.discussion_locked;
        },
        isConfidential () {
            return this.getNoteableData.confidential;
        }
    },
    created () {
        if (!badgeState.state && this.initialState) {
            badgeState.state = this.initialState;
        }
        if (!badgeState.updateStatus) {
            badgeState.updateStatus = this.fetchState;
        }
    },
    beforeDestroy () {
        if (badgeState.updateStatus && this.query) {
            badgeState.updateStatus = null;
        }
    },
    methods: {
        async fetchState () {
            const { data } = await this.$apollo.query({
                query: this.query,
                variables: {
                    projectPath: this.projectPath,
                    iid: this.iid
                },
                fetchPolicy: fetchPolicies.NO_CACHE
            });
            badgeState.state = data?.namespace?.issuable?.state;
        }
    }
};
